














































































































import {
  BroadcastMasterGetIsSeenNotificationListByMerchantId,
  BroadcastMasterGetNotificationCountByMerchantId,
  BroadcastMasterGetUnSeenNotificationListByMerchantId,
} from "@/broadcastChannel/userChannel";
import { LoadingStatusType, NotificationMessageType, NotificationType, TransactionType } from "@/enums/enums";
import {
  CheckMerchantIsActiveOtherTab,
  CheckMerchantIsLoadNotificationIsSeen,
  CheckMerchantIsLoadNotificationUnSeen,
  CheckNotificationIsNotChangeURL,
  ConvertNotificationMessageListToNotificationMessageForDisplayList,
  DoGetIsSeenNotificationList,
  DoGetUnSeenNotificationList,
  DoGetUnseenNotificationCount,
  DoSetNotificationIsSeenAll,
  DoSetNotificationIsSeenById,
  ForceSetMaster,
  GetAllDataForDisplayNotification,
  GetObjectIdListNotification,
  SortDataNotification,
} from "@/helper/notificationHelper";
import { IsMasterTab } from "@/helper/tabHelper";
import { MerchantId } from "@/helper/userHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { NotificationMessageForDisplayModel } from "@/model/notification/NotificationMessageForDisplayModel";
import { NotificationMessageModel } from "@/model/notification/NotificationMessageModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const StoreNotification = namespace("Notification");
const StoreLogIn = namespace("LogIn");
@Component
export default class Notification extends Vue {
  private showNotification = false;
  private notificationListUnreadCount = 0;
  private isUnSeenOnly = true;
  private isShowOptionDropdown = false;
  private allNotificationList: Array<NotificationMessageForDisplayModel> = [];
  private filterNotificationList: Array<NotificationMessageForDisplayModel> = [];
  private displayNotificationList: Array<NotificationMessageForDisplayModel> = [];
  private tabs = [
    {
      name: NotificationType.None,
      label: this.$t("Notification.Tab_All"),
      unreadCount: 0,
    },
    {
      name: NotificationType.System,
      label: this.$t("Notification.Tab_System"),
      unreadCount: 0,
    },
    {
      name: NotificationType.Mention,
      label: this.$t("Notification.Tab_Mention"),
      unreadCount: 0,
    },
    {
      name: NotificationType.Download,
      label: this.$t("Notification.Tab_Download"),
      unreadCount: 0,
    },
  ];
  private activeTab = NotificationType.None;
  private animation = false;
  private isLoading = false;
  private NotificationMessageType = NotificationMessageType;

  @StoreNotification.Getter
  private getUnSeenNotificationList!: Array<NotificationMessageModel>;
  @StoreNotification.Getter
  private getIsSeenNotificationList!: Array<NotificationMessageModel>;
  @StoreNotification.Getter
  private getNotificationCount!: number;
  @StoreNotification.Getter
  private getNotificationReadyToUse!: boolean;
  @StoreNotification.Getter
  private getNotificationListLoadingStatus!: LoadingStatusType;
  @StoreNotification.Getter
  private getNotificationCountLoadingStatus!: LoadingStatusType;
  @StoreNotification.Getter
  private getNotificationIsAuthenticated!: LoadingStatusType;

  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;

  @StoreNotification.Action
  private DoUpdateNotificationIsSeen!: () => void;
  @StoreNotification.Action
  private DoDeleteNotificationById!: (id: string) => void;

  created() {
    if (this.getNotificationReadyToUse) {
      this.GetNotificationCount();
    }
  }

  mounted() {
    const listBoxNotification: any = this.$refs.listBoxNotification;
    listBoxNotification.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("getNotificationReadyToUse")
  getNotificationReadyToUseChanged(newVal: boolean) {
    if (!newVal) {
      this.showNotification = false;
    } else {
      this.GetNotificationCount();
    }
  }

  @Watch("getNotificationCountLoadingStatus")
  getNotificationCountLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      this.SetUnreadCount();
      if (this.getNotificationCount > 0 && this.showNotification) {
        this.GetUnSeenNotificationList();
      }
    }
  }

  @Watch("getNotificationListLoadingStatus")
  async getNotificationListLoadingStatusChange(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      await this.SetFilterNotificationList();
    }
  }

  @Watch("activeTab")
  async activeTabChange() {
    await this.SetFilterNotificationList();
  }

  @Watch("getNotificationIsAuthenticated")
  getNotificationIsAuthenticatedChange(newVal: boolean) {
    if (newVal) {
      this.GetNotificationCount();
    }
  }

  @Watch("showNotification")
  showNotificationChange(newVal: boolean) {
    if (!newVal) {
      this.displayNotificationList = [];
    }
  }

  public HandleScroll() {
    const listBoxNotification: any = this.$refs.listBoxNotification;
    const scrollHeight = listBoxNotification.scrollHeight;
    const scrollTop = listBoxNotification.scrollTop;
    const clientHeight = listBoxNotification.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.displayNotificationList.length < this.filterNotificationList.length) {
        this.displayNotificationList.push(this.filterNotificationList[this.displayNotificationList.length]);
      }
    }
  }

  public ResetDatalistDisplay() {
    this.displayNotificationList = [];
    if (this.filterNotificationList) {
      for (let i = 0; i < 10; i++) {
        if (i < this.filterNotificationList.length) {
          this.displayNotificationList.push(this.filterNotificationList[i]);
        }
      }
    }

    setTimeout(() => {
      this.isLoading = false;
    }, 0);
  }

  public ToggleNotificationDropdown() {
    if (this.getNotificationReadyToUse) {
      this.showNotification = !this.showNotification;
      if (this.showNotification) {
        this.GetUnSeenNotificationList();
      } else {
        this.isUnSeenOnly = true;
      }
    }
  }

  public HideNotificationDropdown() {
    this.isUnSeenOnly = true;
    this.showNotification = false;
  }

  public HideOptionDropdown() {
    this.isShowOptionDropdown = false;
  }

  public GetActionLabelByCategory(notification: NotificationMessageForDisplayModel) {
    switch (notification.notificationTypeId) {
      case NotificationType.Mention:
      case NotificationType.System:
        if (CheckNotificationIsNotChangeURL(notification.messageTypeId)) {
          return "";
        } else {
          return this.$t("Notification.View_Button");
        }
      case NotificationType.Download:
        return this.$t("Notification.Download_Button");
    }
    return "";
  }

  public GetTimeFormat(dateTime: any) {
    if (!dateTime) {
      return "";
    }

    const date = new Date(dateTime);
    const hours = date
      .getHours()
      .toString()
      .padStart(2, "0");
    const minutes = date
      .getMinutes()
      .toString()
      .padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  public SetUnreadCount() {
    let systemUnreadCount = 0;
    let mentionUnreadCount = 0;
    let downloadUnreadCount = 0;

    for (const notification of this.allNotificationList) {
      systemUnreadCount +=
        Boolean(!notification.isSeen) && notification.notificationTypeId === NotificationType.System ? 1 : 0;
      mentionUnreadCount +=
        Boolean(!notification.isSeen) && notification.notificationTypeId === NotificationType.Mention ? 1 : 0;
      downloadUnreadCount +=
        Boolean(!notification.isSeen) && notification.notificationTypeId === NotificationType.Download ? 1 : 0;
    }

    this.notificationListUnreadCount = this.getNotificationCount;
    this.tabs[0].unreadCount = this.getNotificationCount;
    this.tabs[1].unreadCount = systemUnreadCount;
    this.tabs[2].unreadCount = mentionUnreadCount;
    this.tabs[3].unreadCount = downloadUnreadCount;
  }

  public async OnClickNotificationItemBox(notification: NotificationMessageForDisplayModel) {
    const notificationId = notification.id;
    const isSeen = notification.isSeen;
    const messageTypeId = notification.messageTypeId;
    const messageUrl = notification.option.messageUrl ?? "";
    const transactionType = notification.option.transactionType ?? TransactionType.None;
    const transactionId = notification.option.transactionId ?? 0;

    if (!isSeen) {
      const merchantId = MerchantId();
      await DoSetNotificationIsSeenById(merchantId, notificationId);
    }
    if (!CheckNotificationIsNotChangeURL(messageTypeId)) {
      if (
        messageTypeId == NotificationMessageType.MentionTransaction ||
        messageTypeId == NotificationMessageType.ApprovedTransaction ||
        messageTypeId == NotificationMessageType.SendApprovedDocumentTransaction
      ) {
        this.OpenTransactionDetail(transactionId, transactionType, messageTypeId);
      } else {
        this.OpenNewTap(messageUrl);
      }
    }
  }

  public OpenTransactionDetail(
    transactionId: number,
    transactionType: TransactionType,
    messageTypeId: NotificationMessageType
  ) {
    const baseUrl = process.env.VUE_APP_PeakAccount;
    const encryptedTransactionId = MerchantId().PeakEncryption();
    const endpointMap: any = {
      [TransactionType.Quotation]: "income/quotationDetail",
      [TransactionType.Invoice]: "income/invoiceDetail",
      [TransactionType.Receipt]: "income/receiptDetail",
      [TransactionType.TaxInvoice]: "income/taxinvoiceDetail",
      [TransactionType.CreditNote]: "income/creditNoteDetail",
      [TransactionType.DebitNote]: "income/debitNoteDetail",
      [TransactionType.BillingNote]: "income/billingNoteDetail",
    };

    let url = `${baseUrl}${
      endpointMap[transactionType]
    }?emi=${encryptedTransactionId}&eii=${transactionId.PeakEncryption()}`;

    if (messageTypeId === NotificationMessageType.MentionTransaction) {
      url += "&mention=true";
    }

    window.open(url);
  }

  public OpenNewTap(linkDocument: string) {
    window.open(linkDocument);
  }

  public async DoReadAllNotification() {
    const merchantId = MerchantId();
    await DoSetNotificationIsSeenAll(merchantId);
  }

  public ChangedIsUnSeenOnly() {
    if (!this.isUnSeenOnly) {
      this.GetIsSeenNotificationList();
    } else {
      this.SetFilterNotificationList();
    }
  }

  public async SetFilterNotificationList() {
    this.allNotificationList = [];
    this.isLoading = true;
    if (this.isUnSeenOnly) {
      this.allNotificationList = [
        ...ConvertNotificationMessageListToNotificationMessageForDisplayList(this.getUnSeenNotificationList),
      ];
    } else {
      this.allNotificationList = [
        ...ConvertNotificationMessageListToNotificationMessageForDisplayList(this.getUnSeenNotificationList),
        ...ConvertNotificationMessageListToNotificationMessageForDisplayList(this.getIsSeenNotificationList),
      ];
    }

    const objectId = GetObjectIdListNotification(this.allNotificationList);

    await GetAllDataForDisplayNotification(objectId, this.allNotificationList, this.getMerchant);

    this.allNotificationList = SortDataNotification(this.allNotificationList);

    if (this.activeTab === NotificationType.None) {
      this.filterNotificationList = this.allNotificationList;
    } else {
      this.filterNotificationList = this.allNotificationList.filter(
        (notification) => this.activeTab === notification.notificationTypeId
      );
    }
    this.ResetDatalistDisplay();
    this.SetUnreadCount();
  }

  public async GetNotificationCount() {
    const merchantId = MerchantId();
    const checkMerchantIsActiveOtherTab = await CheckMerchantIsActiveOtherTab(merchantId);
    if (IsMasterTab()) {
      DoGetUnseenNotificationCount(merchantId);
    } else {
      if (checkMerchantIsActiveOtherTab) {
        this.$store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
      } else {
        BroadcastMasterGetNotificationCountByMerchantId(merchantId);
      }
    }
  }

  public async GetUnSeenNotificationList() {
    const merchantId = MerchantId();
    const checkMerchantIsLoadNotification = await CheckMerchantIsLoadNotificationUnSeen(merchantId);
    if (checkMerchantIsLoadNotification && this.getNotificationCount == 0) {
      this.$store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    } else {
      if (IsMasterTab()) {
        DoGetUnSeenNotificationList(merchantId);
      } else {
        BroadcastMasterGetUnSeenNotificationListByMerchantId(merchantId);
      }
    }
  }

  public async GetIsSeenNotificationList() {
    const merchantId = MerchantId();
    const checkMerchantIsLoadNotification = await CheckMerchantIsLoadNotificationIsSeen(merchantId);
    if (checkMerchantIsLoadNotification) {
      this.$store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    } else {
      if (IsMasterTab()) {
        DoGetIsSeenNotificationList(merchantId);
      } else {
        BroadcastMasterGetIsSeenNotificationListByMerchantId(merchantId);
      }
    }
  }

  public async SetThisMaster() {
    this.animation = true;
    const merchantId = MerchantId();
    await ForceSetMaster(merchantId);
    setTimeout(() => {
      this.animation = false;
    }, 1000);
  }
}
